import React, {ReactNode} from "react";
import '../../styles/common/info-modal.scss';
import Modal from "./Modal";
import {FontIcon, Icon} from "./FontIcon";

interface IInfoModalProps {
  onClose: ()=> void;
  heroAdditionalClassName?: string;
  title: string;
  text: ReactNode,
  hero?: ReactNode,
  icon: Icon,
}

export default function InfoModal({onClose, heroAdditionalClassName="", title, text, hero, icon}: IInfoModalProps) {
  const content = createContent(title, text, heroAdditionalClassName, hero, icon);
  return (
    <Modal additionalClassName={"info-modal"} onClose={onClose} midiCloseShortcutNote={'B'} >
      {content}
    </Modal>
  );
}

function createContent(title: string, text: ReactNode, heroAdditionalClassName: string, hero: ReactNode | undefined, icon: Icon){
  const heroEl = hero || (
    <div className={`hero ${heroAdditionalClassName}`}>
      <FontIcon icon={icon}/>
    </div>
  );
  return (
    <div className="info-content">
      {heroEl}
      <div className="title">{title}</div>
      <div className="line"> <div>&nbsp;</div> </div>
      <div className="text">
        {text}
      </div>
    </div>
  );
}